import { useAuthStore } from '@/modules/auth/store/auth';

export default defineNuxtRouteMiddleware(async (to, from) => {
  const { hasLoggedInUser, onboardingCompleted } = useAuthStore();
  if (hasLoggedInUser && onboardingCompleted === true) {
    return navigateTo('/');
  }
});
